import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import { Link as ScrollLink } from 'react-scroll'
import {Row, Col} from 'react-flexbox-grid'
import ReactPlayer from 'react-player'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
  Grade,
  Changelog,
  ScrollToTop
} from '../../components'
import Styles from './HowItWorks.css'

@CSSModules(Styles, {allowMultiple:true})
export default class HowItWorks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDataSources: false,
      wffSourcesSorted: config.wffSources.slice().sort(
        (a, b) => a[0].localeCompare(b[0], 'en', { sensitivity: 'base' }),
      )
    }
  }

  componentWillMount() {
    // if (typeof window !== 'undefined') {
    //   window.scrollTo(0,0)
    // }
  }

  render() {
    const title = 'How it works'
    const description = 'Get your money out of arms manufacturers. Weapon Free Funds tracks weapon investments for thousands of mutual funds commonly found in retirement plans.'
    const url = config.domain + config.routes.howitworks

    // const bannerImage = 'green'
    // const bannerHeadline = 'How it works'
    // const bannerSubtitle = 'Getting started with Weapon Free Funds'

    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifIcon = require( '../../../static/images/ussif-logo.png' )
    // const cleanChartImg = require( '../../../static/images/wff-howitworks-clean-chart.png' )
    // const dirtyChartImg = require( '../../../static/images/wff-howitworks-dirty-chart.png' )
    // const categorySwitchesImg = require( '../../../static/images/wff-howitworks-categories-table.png' )
    // const categoryChartImg = require( '../../../static/images/wff-howitworks-companies-chart.png' )
    // const categoryHoldingsImg = require( '../../../static/images/wff-howitworks-companies-table.png' )
    // const iconMmc = require( '../../../static/images/icn-mmc.svg' )
    // const iconCm = require( '../../../static/images/icn-cm.svg' )
    // const iconNw = require( '../../../static/images/icn-nw.svg' )

    return (
      <div styleName='howitworkspage' id='top'>
        {container.helmet(title, description, url)}

        <ContainerDivs>
          <Row styleName='title-nav-row'>
            <Col xs={12} sm={8} styleName='title-nav-title'>
              <h1 styleName='title'>
                How it works
              </h1>
              <p styleName='subtitle'>
                Getting started,
                methodology,
                and military weapon company lists
              </p>
              <p styleName='lede'>
                Weapon Free Funds sources financial data from SEC's Edgar database. We use mutual fund and stock data to analyze funds and track military weapon investments. Our tool covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.
              </p>
            </Col>

            <Col xs={12} sm={4} styleName='title-nav-nav'>
              <nav styleName='page-nav'>
                <div styleName='page-nav-title'>
                  Sections
                </div>
                {
                  [
                    ['Getting started','getting-started'],
                    ['Companies','companies'],
                    ['Grades','military-weapon-grades'],
                    // ['Fund managers','fund-manager-ratings'],
                    ['Spreadsheet','spreadsheet'],
                  ].map((e, i) => {
                    return <ScrollLink
                      key={'nav-scroll-link-'+i}
                      to={e[1]}
                      spy
                      smooth
                      duration={500}
                      title={e[0]}
                    >
                      <div styleName='page-nav-btn'>
                        {e[0]}
                      </div>
                    </ScrollLink>
                  })
                }
              </nav>
            </Col>
          </Row>
        </ContainerDivs>

        <Works/>

        <ContainerDivs>
          <section styleName='methodology-section'>
            <div styleName='anchor' id='getting-started'/>
            <h2 styleName='section-title'>
              Getting started
            </h2>
            <h3 styleName='answer-title'>
              Video tutorial
            </h3>
            <div styleName='answer-info'>
              <div styleName='media-react-player-wrap'>
                <ReactPlayer
                  url='https://vimeo.com/694938191'
                  volume={0.75}
                />
              </div>
            </div>

            <div styleName='x-fund-info-photo'>
              <div
                styleName='x-fund-photo'
                title='401(k) retirement plans'
              />
              <div styleName='x-fund-info'>
                <h3 styleName='x-fund-info-title'>
                  Mutual funds
                </h3>
                <p>
                  Mutual funds are collections of stocks bundled together, sometimes hundreds or thousands of companies. They are some of the most popular investment products for retirement plans, because owning so many company stocks at once helps diversify investment risk. But unless you're a financial professional, it can be difficult to find out just what companies are inside the funds you're invested in. That's where we come in. We examine every holding in thousands of funds to determine if there are investments in weapon stocks.
                </p>
              </div>
            </div>

            <div styleName='x-sri-info-photo'>
              <div
                styleName='x-sri-photo'
                title='401k retirement plans'
              />
              <div styleName='x-sri-info'>
                <h3 styleName='x-sri-info-title'>
                  Sustainable investing
                </h3>
                <p>
                  Some funds actively choose to invest sustainably, by considering environmental or social issues when choosing companies to invest in. If you're thinking about weapon free investing, sustainably-mandated funds can be a good place to start, because they often deliberately avoid investments in arms manufacturers and military contractors.
                </p>
              </div>
            </div>

            <div styleName='x-returns-info-photo'>
              <div
                styleName='x-returns-photo'
                title='401k retirement plans'
              />
              <div styleName='x-returns-info'>
                <h3 styleName='x-returns-info-title'>
                  Sustainable investing can offer competitive returns
                </h3>
                <p>
                  While people may become interested in sustainable investing because of personal values and goals, that doesn't mean they're not looking for a competitive financial return on their investments. Fortunately, the evidence is clear: sustainable investors do not have to pay more to align their investments with their values, or to avoid companies with poor environmental, social or governance practices. <Link to={config.links.ussifperf} title='Performance and SRI' xstrong>The Forum for Sustainable and Responsible Investment</Link> has collected the research.
                </p>
              </div>
            </div>

            <h3 styleName='answer-title'>
              Finding funds
            </h3>
            <div styleName='answer-info'>
              <p>
                <strong>Weapon Free Funds</strong> sources financial data on
                equities and mutual funds from SEC's Edgar database. Our tool
                contains information on thousands of U.S. open-end and exchange
                traded mutual funds, some of the most common funds held in
                401(k)s, 403(b)s, and other retirement plans.
              </p>
              <p>
                Search for mutual funds using name, ticker symbol, or asset
                manager. <Link
                  to={config.routes.clean}
                  title='Search funds'
                  xstrong
                >Use the search page</Link> to filter funds by investing style,
                fund family, and more. When you find a fund you're looking for,
                click on it to see the full results.
              </p>
              <p>
                We don't have everything in our database &mdash; we only screen
                mutual funds that are at least 50% invested in
                stock investments, and our data license restricts us to
                displaying only 3,000 portfolios.
              </p>
              <p>
                Looking for your favorite fund and
                can&rsquo;t find it? With more resources, we could include more
                funds &mdash; <Link
                  to={config.links.donate}
                  title='Donate to As You Sow'
                  xstrong
                >make a gift today to make a difference.</Link>
              </p>

              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Research universe</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    Our database covers open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don’t have data on funds domiciled outside the U.S. The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don’t have ratings for fixed income funds. We exclude funds with less than 50% of fund assets in equity holdings from the analysis universe.
                  </p>
                </div>
              </div>
            </div>
            <ScrollToTop />
          </section>

          <section styleName='methodology-section'>
            <div styleName='anchor' id='companies'/>
            <h2 styleName='section-title'>
              Companies
            </h2>
            <h3 styleName='answer-title'>
              Identifying military weapon stocks
            </h3>
            <div styleName='answer-info'>
              <p>
                Our analysis checks funds for direct stock investments in <strong>military contractors</strong>. This list includes two sub-categories: manufacturers and servicers of <strong>nuclear weapons</strong>; and current and recent manufacturers of <strong>controversial weapons</strong>, such as cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium.
              </p>
              <p>
                To build these exclusion lists, we used data from over 20 sources, including investment firms and pension funds with ethical investment guidelines; data from industry news outlets; and research from non-profit advocacy groups.
              </p>
              <button
                onClick={() => {
                  this.setState({showDataSources: !this.state.showDataSources})
                }}
                styleName='source-btn'
              >
                See data sources<LinkIcon
                  faclass={this.state.showDataSources ? 'fa-angle-up' : 'fa-angle-down'}
                />
              </button>
              <SlideDown>
                { this.state.showDataSources ?
                    <div styleName='source-slidedown'>
                      {
                        this.state.wffSourcesSorted.map((e, i) => {
                          console.log(i, e)
                          const sourceShortname = e[0]
                          const sourceDesc = e[1]
                          const sourceFullname = e[2]
                          let source_filename = e[3]
                          if (source_filename.slice(-3) === 'pdf' ||
                              source_filename.slice(-4) === 'xlsx') {
                            source_filename = config.links.exclusionListsS3 + source_filename
                          }
                          return <div styleName='source-item'>
                            <h3 styleName='source-shortname'></h3>
                            <p><strong>{sourceShortname}</strong> - {sourceDesc}
                            <br/>
                            <Link
                              to={source_filename}
                              xstrong
                              title={sourceFullname}
                            >
                              {sourceFullname}
                            </Link></p>
                          </div>
                        })
                      }
                    </div> : null
                }
              </SlideDown>
              <p>
                The full lists of flagged companies are below. Click a company name to see the source data we used to include the company on that list.
              </p>
              <ScreenedCompanies />
            </div>
            <ScrollToTop />
          </section>

          <section styleName='methodology-section'>
            <div styleName='anchor' id='military-weapon-grades'/>
            <h2 styleName='section-title'>
              Grades
            </h2>
            <h3 styleName='answer-title'>
              Calculating exposure to military weapon companies
            </h3>
            <div styleName='answer-info'>
              <p>
                Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund’s assets that are invested in those companies.
              </p>
              <p>
                We only look for direct stock holdings in weapon companies. That means that holdings that are not stocks, like cash holdings or bonds, are not rated. In the fund's investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund&rsquo;s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden weapon-related investments that our tool cannot account for, in the form of bond holdings or other asset types.
              </p>
              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Measuring long holdings only</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
                  </p>
                </div>
              </div>
            </div>

            <h3 styleName='answer-title'>
              Military weapon grades
            </h3>
            <div styleName='answer-info'>
              <p>Based on the fund's military weapon exposure, it earns one of five military weapon grades.</p>
              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={1} />
                  <p styleName='screen-icon-label'>
                    No holdings flagged for our military weapon screens. Assigned a grade of A.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={2} />
                  <p styleName='screen-icon-label'>
                    Fund is not invested in nuclear weapons or controversial weapons,
                    but is invested in military contractors,
                    below the threshold of 2.5%. Assigned a grade of B.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={3} />
                  <p styleName='screen-icon-label'>
                    Fund is invested in nuclear weapons and/or controversial weapons
                    below the threshold of 2.5%. Assigned a grade of C.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={4} />
                  <p styleName='screen-icon-label'>
                    Fund is invested in military contractors
                    above the threshold of 2.5% and below the threshold of 4%.
                    Assigned a grade of D.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                <Grade grade={5} />
                <p styleName='screen-icon-label'>
                  Fund is invested in military contractors
                  above the threshold of 4%.
                  Assigned a grade of F.
                </p>
                </div>
              </div>
            </div>

            <h3 styleName='answer-title'>
              Details on military weapon exposure
            </h3>
            <div styleName='answer-info'>
              <p>
                Along with the military weapon grade, we show details on the
                fund portfolio's flagged holdings.
              </p>
              <p>
                The number of flagged holdings, the amount invested by the fund,
                and the percent of the fund's portfolio those holdings make up
                are shown. The same figures are available for the sub-categories
                of nucler weapons and controversial weapons, and for each
                individual flagged holding.
              </p>
              <p>
                Clicking on any flagged holding will show the source data used
                to include that company on the military weapons company list.
              </p>

              { /* <p>
                If a fund has a weapon grade of A and does not have direct stock investments in any of the weapon companies we screen for, you'll see a chart like this:
              </p>
              <img
                styleName='clean-chart-img'
                src={cleanChartImg}
                alt='Five-badge fund chart'
              />
              <p>However, if a fund does have direct stock investments in any of the weapon companies we screen for, you'll see a chart like this, showing the overall exposure.</p>
              <img
                styleName='dirty-chart-img'
                src={dirtyChartImg}
                alt='Chart for fund that owns stock in weapon companies'
              />
              <p>Next to the chart, you'll see the exposure breakdown for each of the three military weapon categories.</p>
              <img
                styleName='category-switches-img'
                src={categorySwitchesImg}
                alt='Breakdown of weapon exposure for each of the five weapon categories'
              />
              <p>
                If you click a category that a fund has exposure to, you'll see the chart change to a breakdown of the individual companies in that category that the fund owns.
              </p>
              <img
                styleName='category-chart-img'
                src={categoryChartImg}
                alt='Chart for a single weapon category'
              />
              <p>
                You'll also see each investment for that weapon category listed below.
              </p>
              <img
                styleName='category-holdings-img'
                src={categoryHoldingsImg}
                alt='Holdings for a single weapon category'
              /> */ }
            </div>

            <h3 styleName='answer-title'>
              Sustainable funds
            </h3>
            <div styleName='answer-info'>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Sustainably-mandated  fund'
                data-multiline
                data-effect='solid'
                data-html
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Designated a sustainable investment. Sustainably-mandated  funds consider issues like the environment and human rights.</div>"
              />
              <ReactTooltip id='sri-icons-tooltip'/>
              <p>
                We display a "sustainability mandate" indicator to show which funds are marketed as sustainable investments. Sustainable funds make investment decisions based on environmental and social risk issues like climate change and human rights. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry.
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt='Member of US-SIF, the Forum for Sustainable and Responsible Investment'
                data-multiline
                data-effect='solid'
                data-html
                data-for='ussif-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>"
              />
              <ReactTooltip id='ussif-icons-tooltip'/>
              <p>
                The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of weapons. Look for this symbol to find funds that are members of US-SIF.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Weapon free action toolkit
            </h3>
            <div styleName='answer-info'>
              <p>
                When you're done looking up funds and finding the data you need, what's next? You can learn how to make a change and move your money with our <Link to={config.routes.toolkit} xstrong title='Weapon free action toolkit'>weapon free action toolkit</Link>. Whether you’re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There's an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more &mdash; everything you need to make a change and get started investing your money weapon free.
              </p>
            </div>
            <ScrollToTop />
          </section>

          { /*
          <section styleName='methodology-section'>
            <div styleName='anchor' id='fund-manager-ratings'/>
            <h2 styleName='section-title'>
              Fund managers
            </h2>
            <h3 styleName='answer-title'>
              Fund manager ratings
            </h3>
            <div styleName='answer-info'>
              <p>
                Mutual funds and ETFs are offered by <strong>fund managers.</strong> These companies manage anywhere between one and several hundred
                fund portfolios, offered to investors as vehicles to save for their futures.
              </p>
              <p>
                To rate fund managers, we take all the funds in our research universe offered by that fund manager and combine them, treating them as one big portfolio. We then apply <ScrollLink
                    to='military-weapon-grades'
                    spy
                    smooth
                    duration={500}
                    title='Military weapon grades'
                  ><span styleName='link-text'>the same grading system</span></ScrollLink> used for individual funds to this set of combined holdings. What we've found is that the largest fund managers are heavily invested in arms manufacturers, including nuclear and controversial weapons. But sustainable and socially responsible fund managers - firms that have at least 50% of assets invested in funds with a sustainable investing mandate - often have less weapons exposure, with many having no investments in nuclear weapons, and almost all avoiding investments in controversial weapons. <Link
                  to={config.routes.fundManagers}
                  title='Fund managers'
                  xstrong
                >See our analysis of fund managers here.</Link>
              </p>
            </div>
            <ScrollToTop />
          </section>
          */ }

          { /* CHANGELOG */ }
          <section styleName='methodology-section'>
            <div styleName='anchor' id='spreadsheet'/>
            <h2 styleName='section-title'>
              Spreadsheet
            </h2>
            <Changelog />
            <ScrollToTop />
          </section>
        </ContainerDivs>

        <br/>
        <br/>
        <br/>

        <GetStartedInput />
      </div>
    )
  }
}
